import type { AccountingSettingsComponentProps } from './AccountingSettingsComponent';

export const AccountingSettingsComponent = {
    MountAsync: async (target: HTMLElement, props: AccountingSettingsComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { AccountingSettingsComponent } = await import('./AccountingSettingsComponent');
        return await mountReactComponentAsync(target, AccountingSettingsComponent, props);
    }
};
